function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["background", "children", "className", "disabled", "showNotificationBadge", "hasOutline", "href", "id", "initialSize", "innerRef", "notificationBadgeLabel", "onClick", "textColor", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import classNames from 'classnames';
import { ButtonOrLink } from '@lmig/lmds-react-button-or-link';
import { IconButtonContext } from './IconButtonContext';
import "./iconButton.css";

// NOTE: This size is independent from the defaultIconSize in lmds-react-icons.
var defaultIconSize = '32';
/**
 * @see [LMDS IconButton documentation and examples](https://designsystem.lmig.com/components/icon-button/code)
 *
 * API:
 *
 * @implements [IconButtonProps](https://designsystem.lmig.com/components/icon-button/code#icon-button-props)
 * @extends [ButtonProps](https://designsystem.lmig.com/components/buttons/code#button-props)
 */
export var IconButton = function IconButton(_ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'white' : _ref$background,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    _ref$showNotification = _ref.showNotificationBadge,
    showNotificationBadge = _ref$showNotification === void 0 ? false : _ref$showNotification,
    _ref$hasOutline = _ref.hasOutline,
    hasOutline = _ref$hasOutline === void 0 ? false : _ref$hasOutline,
    href = _ref.href,
    id = _ref.id,
    _ref$initialSize = _ref.initialSize,
    initialSize = _ref$initialSize === void 0 ? defaultIconSize : _ref$initialSize,
    innerRef = _ref.innerRef,
    notificationBadgeLabel = _ref.notificationBadgeLabel,
    onClick = _ref.onClick,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'darkGray' : _ref$textColor,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(initialSize),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var handleClick = function handleClick(event) {
    if (disabled) {
      return event.preventDefault();
    }
    return onClick && onClick(event);
  };
  return /*#__PURE__*/React.createElement(ButtonOrLink, _extends({
    id: id,
    type: type,
    className: classNames('lm-IconButton', _defineProperty(_defineProperty(_defineProperty({}, "lm-IconButton--".concat(size), size), "lm-IconButton--".concat(background), background), 'lm-IconButton--hasOutline', hasOutline), _defineProperty({}, "lm-IconButton-textColor--".concat(textColor), textColor === 'white'), className),
    href: href,
    "aria-disabled": disabled,
    onClick: handleClick,
    innerRef: innerRef
  }, rest), /*#__PURE__*/React.createElement(IconButtonContext.Provider, {
    value: setSize
  }, children, showNotificationBadge ? /*#__PURE__*/React.createElement("div", {
    className: classNames('lm-IconButton-notification-badge', _defineProperty({}, "lm-IconButton-notification-badge--".concat(size), size))
  }, notificationBadgeLabel ? /*#__PURE__*/React.createElement("span", {
    className: "lm-IconButton-notification-badge-label"
  }, notificationBadgeLabel) : null) : null));
};
IconButton.propTypes = {
  /** Add an optional ID to the element with the class `lm-IconButton`. */id: _pt.string,
  /** Add custom classes to the element with the class `lm-IconButton`. */className: _pt.string,
  /** A ref that attaches to the underlying DOM element to manage focus, values, etc. */innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  /** Set the button type, if necessary. */type: _pt.oneOf(['button', 'submit', 'reset']),
  /**
     * Set the button background style, if necessary.
     * @default 'white'
     */
  background: _pt.oneOf(['white', 'teal', 'transparent', 'onAtmo']),
  /**
     * By default, icon text displays in Dark Gray.
     * When placing an inverse icon button on a Liberty Blue background, use textColor="white".
     * @default 'darkGray'
     */
  textColor: _pt.oneOf(['darkGray', 'white']),
  /** When an href is provided, an anchor tag will be generated instead of a button. */href: _pt.string,
  /** Disable the button. */disabled: _pt.bool,
  /**
     * If true, the icon button will be rendered with a 2px gray outline.
     * @default 'false'
     */
  hasOutline: _pt.bool,
  /** Pass additional functionality to run on click events. */onClick: _pt.func,
  /** Button text and additional elements (e.g., text with an icon) should be passed as children. Children are rendered inside of the element with the class `lm-IconButton`. */children: _pt.node,
  /** If true, the icon button will be rendered with a notification badge. */showNotificationBadge: _pt.bool,
  /** Text or number to be displayed in the notification badge. */notificationBadgeLabel: _pt.node
};
IconButton.displayName = 'IconButton';